import { getCountries } from "react-phone-number-input";
import flags from "react-phone-number-input/flags";
import en from "react-phone-number-input/locale/en.json";

import { useMemo } from "react";
import React from "react";

export interface CountryOption {
  key: string;
  value: string;
  label: React.ReactNode;
}

export const useCountryOptions = (): CountryOption[] => {
  return useMemo(() => {
    return getCountries().map((countryCode) => {
      const Flag = flags[countryCode as keyof typeof flags];

      return {
        key: en[countryCode],
        value: en[countryCode],
        label: (
          <div className="flag-wrapper-container">
            <div className="flex items-center gap-2">{en[countryCode]}</div>
          </div>
        ),
      };
    });
  }, []);
};
